// initial seller pricing structure
export const tara_seller_pricing_plans_structure = [
  {
    id: 1,
    name: 'Starter',
    monthly_slug: 'starter-tara',
    annual_slug: 'starter-tara-annually',
    monthly_price: '€0',
    annual_price: '€0',
    monthly_price_number: 0,
    annual_price_number: 0,
    description: 'Best value for smaller webshops',
    currency: 'EUR',
    features: [
      'Best value for smaller webshops',
      'Up to 1,000 tokens per month',
      'Unlimited integrations',
    ],
    is_most_popular: false,
    role: 'seller',
  },
  {
    id: 2,
    name: 'Business',
    monthly_slug: 'business-tara',
    annual_slug: 'business-tara-annually',
    monthly_price: '€0',
    annual_price: '€0',
    monthly_price_number: 0,
    annual_price_number: 0,
    description: 'Our most popular package',
    currency: 'EUR',
    features: [
      'Our most popular package',
      'Everything from Starter',
      'Up to 10,000 tokens per month',
      'TARA AI Insights',
      'TARA AI Optimize',
    ],
    is_most_popular: true,
    role: 'seller',
  },
  {
    id: 3,
    name: 'AI Expert',
    monthly_slug: 'ai-expert-tara',
    annual_slug: 'ai-expert-tara-annually',
    monthly_price: '€0',
    annual_price: '€0',
    monthly_price_number: 0,
    annual_price_number: 0,
    description: 'For your enterprise needs',
    currency: 'EUR',
    features: [
      'For your enterprise needs',
      'Everything from Business',
      'Up to 150,000 tokens per month',
      'TARA AI Insights with Monitoring',
      'Preferred customer support',
    ],
    is_most_popular: false,
    role: 'seller',
  },
];

// initial agency structure
export const tara_agency_pricing_plans_structure = [
  {
    id: 3,
    name: 'Agency',
    monthly_slug: 'monthly-agency',
    annual_slug: 'yearly-agency',
    monthly_price: '€0',
    annual_price: '€0',
    monthly_price_number: 0,
    annual_price_number: 0,
    monthly_per_seat_price: '0',
    monthly_per_seat_price_number: 0,
    annual_per_seat_price: '0',
    annual_per_seat_price_number: 0,
    description: 'Perfect for agency operations',
    currency: 'EUR',
    features: [
      'Unlimited integrations',
      'TARA AI Insights with Monitoring',
      'Priority customer support',
    ],
    is_most_popular: true,
    role: 'agency',
  },
];

export const tara_seller_pricing_hierarchy = {
  'starter-tara': 1,
  'starter-tara-annually': 2,
  'business-tara': 3,
  'business-tara-annually': 4,
  'ai-expert-tara': 5,
  'ai-expert-tara-annually': 6,
};

export const tara_agency_pricing_hierarchy = {
  'monthly-agency': 1,
  'yearly-agency': 2,
};
